import { JIRA_SUPPORT_REPORT_ISSUE_LINK } from 'constants/links'
import { HelpLink } from 'elements/link/HelpLink'
import { Link } from 'opensolar-ui'
import useTranslateParse from '../../../util/useTranslateParse'

const BatterySubtitle = () => {
  const translateParse = useTranslateParse()
  return (
    <span>
      {translateParse(
        "Search our extensive database, and add batteries to your 'active' list so your team can use them to design. Non-admins do not have the ability to search the database and can only use equipment on this list. If any equipment is missing from the database, <supportLink>contact OpenSolar Support<supportLink> and we will add it, or you can create your own.",
        {
          supportLink: (label) => (
            <Link href={JIRA_SUPPORT_REPORT_ISSUE_LINK} target="_blank" rel="noreferrer">
              {label}
            </Link>
          ),
        }
      )}{' '}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12363053307663-How-to-add-your-hardware-components" />
    </span>
  )
}

const ActiveBatteriesName = ({ translate, style }) => {
  return <span style={style}>{translate('Edit Battery')}</span>
}

export default {
  list: { lazy: () => import('./activeBatteries'), component: 'ActiveBatteriesList' },
  edit: { lazy: () => import('./activeBatteries'), component: 'ActiveBatteriesEdit' },
  create: { lazy: () => import('./activeBatteries'), component: 'ActiveBatteriesCreate' },
  options: {
    create: {
      title: 'Battery Activation',
      subtitle: null,
      breadCrumb: 'Battery Activation',
    },
    list: {
      title: 'My Active Batteries List',
      subtitle: <BatterySubtitle />,
      breadCrumb: 'Batteries',
    },
    edit: {
      title: <ActiveBatteriesName />,
      subtitle: null,
      breadCrumb: 'Edit Battery',
    },
  },
}
